const unauthPaths = [
  '/login',
  '/register',
  '/verify',
  '/forgot-password',
  '/setup-newpassword',
  '/setup-user-details',
];

const isUnauthorizedPath = (pathname: string): boolean => {
  for (const path of unauthPaths) {
    if (pathname.startsWith(path)) return true;
  }
  return false;
};

export default isUnauthorizedPath;
